import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { Setter, Store } from "../utils/storage";
import { postQuery } from "../utils/api";
import { getLocations } from "../utils/queries";


const storage = Store("session");

// Define Initial State
const State = {
    attractions: [],
    loadingAttractions: false,
};

// Define Actions
const Actions = (_set, get) => {
    const set = Setter(_set);
    const URL = process.env.REACT_APP_ENDPOINT;

    // Fetch Attractions from API
    const fetchAttractions = async () => {
        set({ loadingAttractions: true });
    
        const URL = process.env.REACT_APP_ENDPOINT;
        
        const response = await postQuery(URL, getLocations);
    
        if (response.response === 200) {
            const allLocations = response.data.getLocations || [];
            const attractions = allLocations.filter(location => location.type === 'attraction');
            
            set({ attractions, loadingAttractions: false });
        } else {
            console.error("Error fetching attractions:", response.error || response);
            set({ attractions: [], loadingAttractions: false });
        }
    };
    
    return {
        fetchAttractions,
    };
};

// Create Store
const AttractionsStore = create(
    persist((set, get) => {
        const actions = Actions(set, get);

        return {
            ...State, 
            fetchAttractions: actions.fetchAttractions,
        };
    },
        {
            name: "app.attractions",
            storage: createJSONStorage(() => storage),
        })
);

export default AttractionsStore;
